<template>
    <div id="global-uploader">

        <!-- 上传 -->
        <uploader
                ref="uploader"
                :options="options"
                :autoStart="false"
                @file-added="onFileAdded"
                @file-success="onFileSuccess"
                @file-progress="onFileProgress"
                @file-error="onFileError"
                class="uploader-app">
            <uploader-unsupport></uploader-unsupport>

            <uploader-btn id="global-uploader-btn" :attrs="attrs" ref="uploadBtn">选择文件</uploader-btn>

            <uploader-list v-show="panelShow">
                <div class="file-panel" slot-scope="props" :class="{'collapse': collapse}">
                    <div class="file-title">
                      <i class="file-btn-icon el-icon-control-leftPriTab" ></i>
                      <div class="file-title-content">Uploading</div>
                      <div class="operate">
                          <el-button @click="fileListShow" type="text" :title="collapse ? $t('resources.open') : $t('resources.fold') ">
<!--                              <i class="file-btn-icon" :class="collapse ? 'el-icon-control-arrowUp': 'el-icon-control-foldDown'"></i>-->

                            <svg-icon icon-class="fold"  class-name='file-btn-icon' style="margin-right: 5px" v-show="!collapse"/>
                            <svg-icon icon-class="open"  class-name='file-btn-icon' style="margin-right: 5px" v-show="collapse"/>
                          </el-button>
                          <el-button @click="close" type="text" :title="$t('resources.close')">
                            <svg-icon icon-class="X"  class-name='file-btn-icon' style="margin-right: 5px"/>
<!--                              <i class="file-btn-icon el-icon-control-minimize"></i>-->
                          </el-button>
                      </div>
                    </div>

                    <ul class="file-list">
                        <li v-for="file in props.fileList" :key="file.id">
                            <uploader-file :class="'file_' + file.id" ref="files" :file="file" :list="true"></uploader-file>
                        </li>
                        <div class="no-file" v-if="!props.fileList.length"><i class="iconfont icon-empty-file"></i>{{ $t ('resources.onUploadFile') }}</div>
                    </ul>
                </div>
            </uploader-list>

        </uploader>

    </div>
</template>

<script>
    /**
     *   全局上传插件
     *   调用方法：Bus.$emit('openUploader', {}) 打开文件选择框，参数为需要传递的额外参数
     *   监听函数：Bus.$on('fileAdded', fn); 文件选择后的回调
     *            Bus.$on('fileSuccess', fn); 文件上传成功的回调
     */
    import '../../common/js/jquery.min.js'
    import {ACCEPT_CONFIG} from './js/config';
    import Bus from './js/bus';
    import SparkMD5 from 'spark-md5';
    import {selectPreUploadCheck,mergerBlockFile,insertPriOneFile,insertPubOneFile,
      selectSystemCloudId} from  '@/api/resources';
    // import {} from  '@/api/schedule';

    // 这两个是我自己项目中用的，请忽略
    // import {Ticket} from '@/assets/js/utils';
    // import api from '@/api';


    var notUploadedChunkNumbers_zip = []; // 已经上传过的文件chunkNumber数组
    var isUploaded_zip =false;// 文件已经上传成功了
    var firstDate = getCurrentDate();

    function getCurrentDate() {
        var now = new Date();
        var year = now.getFullYear(); //得到年份
        var month = now.getMonth(); //得到月份
        var date = now.getDate(); //得到日期
        month = month + 1;
        if (month < 10) month = "0" + month;
        if (date < 10) date = "0" + date;
        return year + month + date;
    }

    export default {
        data() {
          let _this = this
          let sysdiskpath = _this.$store.state.user.sysdiskpath
          var sysdiskpathData = typeof sysdiskpath == 'string' ? JSON.parse(sysdiskpath): sysdiskpath;
          let addrWeb = sysdiskpathData.addrWeb
          let subAddrWeb = sysdiskpathData.subAddrWeb
          let httpData = ''
          if(sysdiskpathData.isHttps){
            httpData = 'https://'
          }else {
            httpData = 'http://'
          }
            return {
                options: {
                    // target:  '/privateCloud/'+ addrWeb +'/IQMediaLibService/fileLoadController/uploadBlockFile',
                    target:  httpData + addrWeb +'/IQMediaLibService/fileLoadController/uploadBlockFile',
                    chunkSize: '3072000',
                    fileParameterName: 'file',
                    maxChunkRetries: 2,
                    simultaneousUploads: 1,
                    headers: {//设置header
                      'Content-Type':'application/json;charset=UTF-8',
                      // 'Access-Control-Allow-Credentials': false,
                      // 'Access-Control-Allow-Origin': '*',
                    },
                    testChunks: true,   //是否开启服务器分片校验
                    // 服务器分片校验函数，秒传及断点续传基础
                    checkChunkUploadedByResponse: function (chunk, message) {
                        let jsonBodyData = JSON.parse(message).jsonBody;
                        let rtnCode = jsonBodyData.rtnCode;
                        if(rtnCode == 0) {
                            // let objMessage = JSON.parse(message).jsonBody.msgBody;
                            let objMessage = jsonBodyData.msgBody;
                            let statue = objMessage.statue;
                            if (statue == 5) { // 整个文件已经存在
                                return true; // return true 会忽略当前整个文件，不会再发送给后台
                            }

                            return (objMessage.existsBlock || []).indexOf(chunk.offset + 1) >= 0
                        } else { // 验证出错，结束上传
                            return true;
                        }
                    },
                    headers: {
                        // Authorization: Ticket.get() && "Bearer " + Ticket.get().access_token
                    },
                    query() {}
                },
                attrs: {
                    accept: ACCEPT_CONFIG.getAll()
                },
                panelShow: false,   //选择文件后，展示上传panel
                collapse: false,
                isPublic:false
            }
        },
        mounted() {
          let _this = this
            Bus.$on('openUploader', query => {
                this.params = query || {};
                //console.log(this.params)
                if (this.$refs.uploadBtn) {
                  // debugger
                  document.getElementById("global-uploader-btn").click();
                  // var btn = document.getElementById("global-uploader-btn");
                  // btn.addEventListener('click',function(){
                  //
                  //   alert("hello wrold");
                  //
                  // },false)
                    // $('#global-uploader-btn').click();
                }
            });
        },
        computed: {
            //Uploader实例
            uploader() {
                return this.$refs.uploader.uploader;
            }
        },
        methods: {
          //文件添加
              onFileAdded(file) {
                if(file.name && file.name.length > 100){
                  this.$message({
                    message: this.$t('resources.uploadNameLengthError'),
                    type: 'error',
                    duration: 2000
                  })
                  // alert("上传文件不能超过1G！")
                  this.uploader.cancel();
                  return false
                }
                // if(file.size > 1073741824){
                //   this.$message({
                //     message: this.$t('resources.uploadError'),
                //     type: 'error',
                //     duration: 2000
                //   })
                //   // alert("上传文件不能超过1G！")
                //   this.uploader.cancel();
                //   // return false
                // }else {
                //   this.panelShow = true;
                //   this.computeMD5(file);
                // }
                this.panelShow = true;
                this.computeMD5(file);
                Bus.$emit('fileAdded');
            },
            onFileProgress(rootFile, file, chunk) {
                // //console.log(`上传中 ${file.name}，chunk：${chunk.startByte / 1024 / 1024} ~ ${chunk.endByte / 1024 / 1024}`)
            },
          // 文件添加成功
            onFileSuccess(rootFile, file, response, chunk) {
                let res = JSON.parse(response).jsonBody;
                // 服务器自定义的错误（即虽返回200，但是是错误的情况），这种错误是Uploader无法拦截的
                if (res.rtnCode) {
                  this.$message({
                    message: this.$t('resources.diskError'+res.rtnCode) ,
                    type: 'error',
                    duration: 2000
                  })
                    // this.$message({ message: res.message, type: 'error' });
                    // 文件状态设为“失败”
                    this.statusSet(file.id, 'failed');
                    return
                }

                let objMessage = res.msgBody;
                let statue = objMessage.statue;

                // 如果服务端返回需要合并
                if (statue == 7) {
                    // 文件状态设为“合并中”
                    this.statusSet(file.id, 'merging');
                    // 合并请求
                    this.mergerBlockFile(file, objMessage);

                    // api.mergeSimpleUpload({
                    //     tempName: res.tempName,
                    //     fileName: file.name,
                    //     ...this.params,
                    // }).then(res => {
                    //     // 文件合并成功
                    //     Bus.$emit('fileSuccess');
                    //
                    //     this.statusRemove(file.id);
                    // }).catch(e => {});

                // 不需要合并
                } else {
                    // 向公有云发送入库数据

                    // this.imgStatusSet(file.id,file.name)
                    this.uploadFileSuccess(file, objMessage, false);

                    // Bus.$emit('fileSuccess');
                    // //console.log('上传成功');
                }
            },
          // 文件添加失败
            onFileError(rootFile, file, response, chunk) {

              this.$message({
                message: response,
                type: 'error',
                duration: 2000
              })
              // if(rtnCode != -2 || rtnCode != -1900){
              //     // 超过已有空间大小
              //     _this.$message({
              //       message: _this.$t("resources.diskError" + rtnCode),
              //       type: 'error',
              //       duration: 2000
              //     })
              //   }
                // this.$message({
                //     message: response,
                //     type: 'error'
                // })
            },

            /**
             * 计算md5，实现断点续传及秒传
             * @param file
             */
            computeMD5(file) {
                let fileReader = new FileReader();
                let time = new Date().getTime();
                let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
                let currentChunk = 0;
                const chunkSize = 10 * 1024 * 1000;
                let chunks = Math.ceil(file.size / chunkSize);
                let spark = new SparkMD5.ArrayBuffer();

                // 文件状态设为"计算MD5"

                this.statusSet(file.id, 'md5');
                this.imgStatusSet(file.id,file.name)
                file.pause();

                loadNext();

                fileReader.onload = (e => {
                    spark.append(e.target.result);

                    if (currentChunk < chunks) {
                        currentChunk++;
                        loadNext();

                        // 实时展示MD5的计算进度
                        this.$nextTick(() => {
                            $(`.myStatus_${file.id}`).text(this.$t('resources.MD5') +' '+ ((currentChunk/chunks)*100).toFixed(0)+'%')
                            $(`.myStatus_${file.id}`).text(this.$t('resources.MD5'))
                        })
                    } else {
                        let md5 = spark.end();
                        this.computeMD5Success(md5, file);
                        // //console.log(`MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${new Date().getTime() - time} ms`);
                    }
                });

                fileReader.onerror = function () {
                    this.error(`${file.name}`+this.$t('resources.fileError'))
                    file.cancel();
                };

                function loadNext() {
                    let start = currentChunk * chunkSize;
                    let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;

                    fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
                }
            },

            computeMD5Success(md5, file) {
                // this.statusSet(file.id, 'md5');
                // 先向公有云验证
                this.selectPreUploadCheck(md5, file, false);

                // 将自定义参数直接加载uploader实例的opts上
                // Object.assign(this.uploader.opts, {
                //     query: {
                //         firstDate: firstDate,
                //         ...this.params,
                //     }
                // })
                //
                // file.uniqueIdentifier = md5;
                // file.resume();
                // this.statusRemove(file.id);
            },

            fileListShow() {
                let $list = $('#global-uploader .file-list');

                if ($list.is(':visible')) {
                    $list.slideUp();
                    this.collapse = true;
                } else {
                    $list.slideDown();
                    this.collapse = false;
                }
            },
            close() {
                this.uploader.cancel();

                this.panelShow = false;
            },

            /**
             * 新增的自定义的状态: 'md5'、'transcoding'、'failed'
             * @param id
             * @param status
             */
            statusSet(id, status) {
                let statusMap = {
                    md5: {
                        text: this.$t('resources.MD5'),
                        bgc: '#fff'
                    },
                    merging: {
                        text: this.$t('resources.merge'),
                        bgc: '#e2eeff'
                    },
                    transcoding: {
                        text: this.$t('resources.transcoding'),
                        bgc: '#e2eeff'
                    },
                    failed: {
                        text: this.$t('resources.uploadFailed'),
                        bgc: '#e2eeff'
                    }
                }

                this.$nextTick(() => {
                    $(`<span class="myStatus_${id}"></span>`).appendTo(`.file_${id} .uploader-file-status`).css({
                        'position': 'absolute',
                        'top': '0px',
                        'left': '0',
                        'right': '0',
                        'bottom': '0',
                        'zIndex': '1',
                        'backgroundColor': statusMap[status].bgc
                    }).text(statusMap[status].text);
                })
            },
            statusRemove(id,name) {

                this.$nextTick(() => {
                    $(`.myStatus_${id}`).remove();
                })
              // this.$nextTick(() => {
              //   this.imgStatusSet(id,name)
              // })

            },

            error(msg) {
                this.$notify({
                    title: this.$t('c.false'),
                    message: msg,
                    type: 'error',
                    duration: 2000
                })
            },
            imgStatusSet(id, fileName) {
              var first = fileName.lastIndexOf(".");//取到文件名开始到最后一个点的长度
              var namelength = fileName.length;//取到文件名长度
              var filesuffix = fileName.substring(first + 1, namelength ).toLowerCase();//截取获得后缀名
              // //console.log(filesuffix)
              let text = ''
              switch (filesuffix){
                case 'png':
                case 'jpg':
                case 'jpeg':
                case 'gif':
                case 'bmp':
                case 'wmf':
                case 'emf':
                case 'tif':
                case 'tiff':
                case 'ico':
                case 'psd':
                  text = require('../../common/images/image.png')
                break
                case 'mp4':
                case 'rmvb':
                case 'mpg':
                case 'wmv':
                case 'flv':
                case 'MID':
                case 'avi':
                case 'mov':
                case 'rm':
                case 'mpeg':
                case 'swf':
                case '3gp':
                case 'vob':
                case 'asf':
                case 'dat':
                  text = require('../../common/images/video.png')
                  break
                case 'mp3':
                case 'wav':
                case 'wma':
                case 'ogg':
                case 'flac':
                case 'aac':
                case 'ape':
                case 'au':
                case 'mid':
                case 'wv':
                  text = require('../../common/images/audio.png')
                  break
                case 'doc':
                case 'docx':
                  text = require('../../common/images/word.png')
                  break

                case 'xls':
                case 'xlsx':
                  text = require('../../common/images/xlsx.png')
                  break
                case 'ppt':
                case 'pptx':
                  text = require('../../common/images/ppt.png')
                  break
                case 'pdf':
                  text = require('../../common/images/pdf.png')
                  break
                case 'txt':
                  text = require('../../common/images/video.png')
                  break

                case 'zip':
                case 'rar':
                  text = require('../../common/images/rar.png')
                default:


              }

              this.$nextTick(() => {
                $(`<span class="imgStatus_${id}"></span>`).appendTo(`.file_${id} .uploader-file-name`).css({
                  'position': 'absolute',
                  'top': '6px',
                  'left': '0',
                  'right': '0',
                  'bottom': '0',
                  'zIndex': '1',
                  'width': '25px',
                  'height': '25px'
                  // 'background': "url(text) no-repeat center"
                  // 'backgroundColor': statusMap['md5'].bgc
                }).html(`<img class="img"  src="${text}" style="width: 25px;height: 25px;background-color: #fff;">`);
              })
            },
            // 上传前验证（请求公有云服务器）
            selectPreUploadCheck(fileMd5, file, isPublic){
                let _this = this;
                let param1 = new Object();
                let param = new Object();
                param1.md5Value = fileMd5;
                param1.fileSize = file.size;
                if(_this.params.file == 1){
                  param1.isPublic = true
                }else {
                  param1.isPublic = false
                }
                param.jsonBody = param1;
                return new Promise((resolve, reject) => {
                    selectPreUploadCheck(param).then(res => {
                        let jsonBodyData = res.jsonBody;
                        let rtnCode = jsonBodyData.rtnCode;
                        if(rtnCode == 0){
                            let msgBody = jsonBodyData.msgBody;
                            if (msgBody != null) {
                                file.cancel()
                                // 说明公有云上此文件记录，秒传，进行入库
                                this.uploadFileSuccess(file, jsonBodyData.msgBody, true);
                            }
                            else {
                                // 无此文件，进行分块传输
                                this.startBlockFileUpload(fileMd5, file);
                                // Object.assign(this.uploader.opts, {
                                //     query: {
                                //         firstDate: firstDate,
                                //         systemName:_this.$store.state.user.systemName,
                                //         ...this.params,
                                //     }
                                // });
                                //
                                // file.uniqueIdentifier = fileMd5;
                                // this.$nextTick(() => {
                                //     file.resume();
                                //     this.statusRemove(file.id,file,name);
                                // })
                            }
                        }
                        else if(rtnCode != -2 || rtnCode != -1900){
                            // 超过已有空间大小
                            _this.$message({
                              message: _this.$t("resources.diskError" + rtnCode),
                              type: 'error',
                              duration: 2000
                            })
                        }
                    }).catch(err => {

                    })
                })
            },

            // 开始分块上传（先请求一个验证Id）
            startBlockFileUpload(fileMd5, file) {
                let _this = this;
                return new Promise((resolve, reject) => {
                    selectSystemCloudId({}).then(res => {
                        let jsonBodyData = res.jsonBody
                        let rtnCode = jsonBodyData.rtnCode
                        if (rtnCode == 0) {
                            let priId = jsonBodyData.msgBody.id
                            Object.assign(_this.uploader.opts, {
                                query: {
                                    firstDate: firstDate,
                                    systemName:_this.$store.state.user.systemName,
                                    checkId: priId,
                                    ...this.params,
                                }
                            });

                            file.uniqueIdentifier = fileMd5;
                            this.$nextTick(() => {
                                file.resume();
                                this.statusRemove(file.id,file,name);
                            })
                        }
                        else {
                            file.cancel();
                        }
                    }).catch(err => {
                        file.cancel();
                        // reject(false)
                    })
                })
            },

            // 分块传完后，合并（请求私有云服务器）
            mergerBlockFile(file, objMessage){
                let _this = this;
                let param1 = new Object();
                let param = new Object();
                let sysdiskpath = this.$store.state.user.sysdiskpath
                var sysdiskpathData = typeof sysdiskpath == 'string' ? JSON.parse(sysdiskpath): sysdiskpath;
                let addrWeb = sysdiskpathData.addrWeb
                let httpData = ''
                if(sysdiskpathData.isHttps){
                  httpData = 'https://'
                }else {
                  httpData = 'http://'
                }
                param1.fileMd5 = objMessage.fileMd5;
                param1.fileName = objMessage.fileName;
                param1.totalChunks = objMessage.totalChunks;
                param1.systemName =_this.$store.state.user.systemName
                param.jsonBody = param1;
                return new Promise((resolve, reject) => {
                    mergerBlockFile(param,httpData + addrWeb).then(res => {
                        let jsonBodyData = res.jsonBody;
                        let rtnCode = jsonBodyData.rtnCode;
                        if(rtnCode == 0){
                            // 文件合并成功，向公有云发送入库数据
                            // this.imgStatusSet(file.id,file.name)
                            this.uploadFileSuccess(file, jsonBodyData.msgBody, true);
                        }
                    }).catch(err => {

                    })
                })
            },

            // 上传完成后，入公有云库（请求公有云服务器）
            uploadFileSuccess(file, objMessage, isRemove) {
              console.log('objMessage',objMessage)
              // this.imgStatusSet(file.id,file.name)
                if (isRemove) {
                    this.statusRemove(file.id,file.name);
                }
                let _this = this;
                if(this.params.file == 1){
                  let param1 = new Object();
                  let param = new Object();
                  param1.fileName = file.fileName
                  param1.fileMd5 = objMessage.fileMd5
                  // param1.fileName = objMessage.fileName
                  param1.fileName = file.name
                  param1.fileSize = objMessage.fileSize
                  param1.filePath = objMessage.filePath
                  param1.dirId = this.params.id

                  //如果是音、视频文件还需要传入以下几个参数。是否为音、视文件，在上传完成后得到（uploadBlockFile、mergerBlockFile的返回值）； 2024/4/29
                  if (objMessage.lengthInTime || objMessage.frameRate || objMessage.videoWidth || objMessage.videoHeight || objMessage.videoCode){
                    param1.lengthInTime = objMessage.lengthInTime
                    param1.frameRate = objMessage.frameRate
                    param1.videoWidth = objMessage.videoWidth
                    param1.videoHeight = objMessage.videoHeight
                    param1.videoCode = objMessage.videoCode
                  }


                  param.jsonBody = param1;
                  return new Promise((resolve, reject) => {
                    insertPubOneFile(param).then(res => {
                      let jsonBodyData = res.jsonBody;
                      let rtnCode = jsonBodyData.rtnCode;
                      if(rtnCode == 0){
                        Bus.$emit('fileSuccess')
                        // 文件合并成功，向公有云发送入库数据
                      }
                    }).catch(err => {

                    })
                  })
                }else {
                  let param1 = new Object()
                  let param = new Object()
                  param1.fileMd5 = objMessage.fileMd5
                  param1.fileName = file.name
                  param1.fileSize = objMessage.fileSize
                  param1.filePath = objMessage.filePath
                  param1.dirId = this.params.id

                  //如果是音、视频文件还需要传入以下几个参数。是否为音、视文件，在上传完成后得到（uploadBlockFile、mergerBlockFile的返回值）； 2024/4/29
                  if (objMessage.lengthInTime || objMessage.frameRate || objMessage.videoWidth || objMessage.videoHeight || objMessage.videoCode){
                    param1.lengthInTime = objMessage.lengthInTime
                    param1.frameRate = objMessage.frameRate
                    param1.videoWidth = objMessage.videoWidth
                    param1.videoHeight = objMessage.videoHeight
                    param1.videoCode = objMessage.videoCode
                  }

                  param.jsonBody = param1;
                  return new Promise((resolve, reject) => {
                    insertPriOneFile(param).then(res => {
                      let jsonBodyData = res.jsonBody;
                      let rtnCode = jsonBodyData.rtnCode;
                      if(rtnCode == 0){
                        Bus.$emit('fileSuccess')
                        // 文件合并成功，向公有云发送入库数据
                      }
                    }).catch(err => {

                    })
                  })
                }

                //....入库请求


            }

        },
        watch: {},
        destroyed() {
            Bus.$off('openUploader');
        },
        components: {}

    }
</script>

<style scoped lang="scss">
    #global-uploader {
        position: fixed;
        z-index: 20;
        right: 15px;
        bottom: 0px;

        .uploader-app {
            width: 520px;
        }

        .file-panel {
            background-color: #fff;
            border: 1px solid #e2e2e2;
          border-radius:10px 10px 0px 0px;
            box-shadow: 0 0 10px rgba(0, 0, 0, .2);

            .file-title {
                display: flex;
                height: 60px;
                padding: 0 15px;
                border-bottom: 1px solid #ddd;
                border-radius:10px 10px 0px 0px;
                background:linear-gradient(0deg,rgba(17,185,255,1),rgba(30,141,255,1));
                color: #fff;
                align-items: center;
                .file-title-content{
                  font-size:18px;
                  font-weight:400;
                  color:rgba(255,255,255,1);
                  margin-left: 20px;
                }
                .el-icon-control-leftPriTab{
                  font-size: 40px;

                }
                .leftPubTa{
                  float: right;
                }
                .operate {
                    flex: 1;
                    text-align: right;
                  .file-btn-icon{
                    color: #ffffff;
                    font-size: 23px;
                  }
                }
            }

            .file-list {
                position: relative;
                height: 240px;
                overflow-x: hidden;
                overflow-y: auto;
                background-color: #fff;
                list-style: none;
                padding: 0px;
                margin: 0px 10px;
                > li {
                  background-color: #fff;

                }

            }

            &.collapse {
                .file-title {
                    background-color: #E7ECF2;
                }
            }
        }

        .no-file {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 16px;
        }
        /*/deep/.uploader-file > */
        /deep/.uploader-file-icon {
            &:before {
                content: '' !important;
            }

            &[icon=image] {
                background: url(./images/image-icon.png);
            }
            &[icon=video] {
                background: url(./images/video-icon.png);
            }
            &[icon=document] {
                background: url(./images/text-icon.png);
            }
        }

        /deep/.uploader-file-actions > span {
            margin-right: 6px;
        }
    }

    /* 隐藏上传按钮 */
    #global-uploader-btn {
        position: absolute;
        clip: rect(0, 0, 0, 0);
    }
</style>



// WEBPACK FOOTER //
// src/components/VueSimpleUploader/globalUploader.vue